import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2e0ce5ee&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2e0ce5ee&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0ce5ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e0ce5ee')) {
      api.createRecord('2e0ce5ee', component.options)
    } else {
      api.reload('2e0ce5ee', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2e0ce5ee&scoped=true", function () {
      api.rerender('2e0ce5ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/zdy_dragging/component/left/hotspotCutout/index.vue"
export default component.exports